import { createContext, useContext, type ReactNode } from 'react';

/**
 * "Is this content already on a surface?"
 *
 * A form section standing directly on the grey page ground needs a card of its
 * own; one inside a panel or a dialog must not draw a second card inside the
 * first. `Panel` and `Dialog` provide `true`, and `FormSection` reads it — so
 * every page gets the same answer without any page choosing it (UX pass: some
 * form sections were white cards and others sat on the page ground, with
 * transparent fields, on the same screen).
 */
const SurfaceContext = createContext(false);

export function OnSurface({ children }: { readonly children: ReactNode }) {
  return <SurfaceContext.Provider value={true}>{children}</SurfaceContext.Provider>;
}

export function useIsOnSurface(): boolean {
  return useContext(SurfaceContext);
}

/** The card every standalone surface uses: the same as `Panel`'s. */
export const SURFACE_CARD_CLASS =
  'rounded-large border border-default-200 bg-white p-4';
